import React, { useState, useEffect } from 'react';
import {
  Dialog, DialogTitle, DialogContent, DialogActions,
  TextField, Button, Box, Typography, Alert, CircularProgress
} from '@mui/material';
import { Send, Email } from '@mui/icons-material';
import { API } from '../context/AuthContext';
import { useSnackbar } from 'notistack';

export default function SendQuoteEmailDialog({ open, quote, onClose, onSent }) {
  const { enqueueSnackbar } = useSnackbar();
  const [email, setEmail] = useState('');
  const [message, setMessage] = useState('');
  const [sending, setSending] = useState(false);
  const [error, setError] = useState('');

  useEffect(() => {
    if (open && quote) {
      setEmail(quote.client?.email || '');
      setMessage('');
      setError('');
    }
  }, [open, quote]);

  const handleSend = async () => {
    if (!email) return setError('Indica un correo de destino');
    setSending(true); setError('');
    try {
      await API.post(`/quotes/${quote._id}/send-email`, { email, message });
      enqueueSnackbar(`Cotización enviada a ${email}`, { variant: 'success' });
      onSent?.();
      onClose();
    } catch (err) {
      setError(err.response?.data?.error || 'Error al enviar el correo');
    } finally {
      setSending(false);
    }
  };

  if (!quote) return null;

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle sx={{ fontWeight: 700, display: 'flex', alignItems: 'center', gap: 1 }}>
        <Email color="primary" /> Enviar cotización {quote.number}
      </DialogTitle>
      <DialogContent sx={{ pt: 2, display: 'flex', flexDirection: 'column', gap: 2.5 }}>
        {error && <Alert severity="error">{error}</Alert>}
        {!quote.client?.email && (
          <Alert severity="warning">Este cliente no tiene correo registrado. Captúralo aquí o agrégalo en su ficha.</Alert>
        )}
        <TextField
          label="Correo del destinatario"
          type="email"
          value={email}
          onChange={e => setEmail(e.target.value)}
          fullWidth
          autoFocus
        />
        <TextField
          label="Mensaje adicional (opcional)"
          value={message}
          onChange={e => setMessage(e.target.value)}
          fullWidth
          multiline
          minRows={3}
          placeholder="Ej. Quedo atento a cualquier duda sobre la propuesta..."
        />
        <Typography variant="caption" color="text.secondary">
          Se adjuntará automáticamente el PDF de la cotización {quote.number}.
        </Typography>
      </DialogContent>
      <DialogActions sx={{ px: 3, pb: 2 }}>
        <Button onClick={onClose}>Cancelar</Button>
        <Button variant="contained" startIcon={sending ? <CircularProgress size={16} color="inherit" /> : <Send />} onClick={handleSend} disabled={sending}>
          {sending ? 'Enviando...' : 'Enviar correo'}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
